// extracted by mini-css-extract-plugin
module.exports = {"box":"SingleBoxContainer_box__3cMbK"};